
export class TokenRecord {
    id: number;
    uuid: string;
    type: string;
    userId: number;  // Target user's ID, if exists at creation
    userEmail: string;  // Target user's Email, if an account does not exist on creation
    deviceId: number;
    organizationId: number;
    siteId: number;
    senderId: number;
    name: string;
    token: string;
    data;
    clientData: string;
    created: Date;
    expires: Date;
    realm: string;

    constructor(data:Partial<TokenRecord>={}) {
        Object.assign(this, data);
    }
}